import { render, staticRenderFns } from "./IdAlerts.vue?vue&type=template&id=3c8caba0&scoped=true"
import script from "./IdAlerts.vue?vue&type=script&lang=ts"
export * from "./IdAlerts.vue?vue&type=script&lang=ts"
import style0 from "./IdAlerts.vue?vue&type=style&index=0&id=3c8caba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8caba0",
  null
  
)

export default component.exports